import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
// Constants
import breakpointsConstants from "../../constants/breakpoints";
import constants from "./constants/devices.constants";
// Types

// Utilities
import languageUtils from "../language/language.utils";
var viewportWidth = function viewportWidth() {
  var _document$documentEle, _document$body;
  return window.innerWidth || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.clientWidth) || 0;
};
var createV4Uuid = function createV4Uuid() {
  return constants.V4_ID_PATTERN.replace(constants.V4_ID_REGEX, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
var getDeviceLoginParams = function getDeviceLoginParams() {
  var deviceUUID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : createV4Uuid();
  return {
    deviceInformation: {
      deviceUUID: deviceUUID,
      webDeviceInfo: {
        version: navigator.userAgent
      }
    },
    language: languageUtils.getUILocale()
  };
};
var isSafariNativeBrowser = function isSafariNativeBrowser() {
  var _navigator, _navigator$vendor;
  return ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$vendor = _navigator.vendor) === null || _navigator$vendor === void 0 ? void 0 : _navigator$vendor.indexOf(constants.VENDORS.APPLE)) > -1 && window.navigator.userAgent.indexOf('AppleWebKit') > -1;
};
var isChromeBrowser = function isChromeBrowser() {
  var _navigator2, _navigator2$vendor;
  return ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : (_navigator2$vendor = _navigator2.vendor) === null || _navigator2$vendor === void 0 ? void 0 : _navigator2$vendor.indexOf('Google')) > -1 && window.navigator.userAgent.indexOf('AppleWebKit') > -1;
};
var isAndroidNativeBrowser = function isAndroidNativeBrowser() {
  return window.navigator.userAgent.indexOf(constants.USER_AGENTS.MOZILLA) > -1 && window.navigator.userAgent.indexOf(constants.USER_AGENTS.ANDROID) > -1 && window.navigator.userAgent.indexOf(constants.USER_AGENTS.APPLE_WEBKIT) > -1 && window.navigator.userAgent.indexOf(constants.USER_AGENTS.CHROME) <= -1;
};
var isMobileDevice = function isMobileDevice() {
  return viewportWidth() < breakpointsConstants.MOBILE - 1;
};
var isTabletDevice = function isTabletDevice() {
  return viewportWidth() >= breakpointsConstants.MOBILE && viewportWidth() <= breakpointsConstants.TABLET;
};
export default {
  createV4Uuid: createV4Uuid,
  getDeviceLoginParams: getDeviceLoginParams,
  isAndroidNativeBrowser: isAndroidNativeBrowser,
  isChromeBrowser: isChromeBrowser,
  isMobileDevice: isMobileDevice,
  isSafariNativeBrowser: isSafariNativeBrowser,
  isTabletDevice: isTabletDevice
};